import React from 'react';
import PropTypes from 'prop-types';
import "./App.css"; // Add your CSS styling here

const DateImage = ({ timestamp }) => {
    const date = new Date(timestamp);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getUTCMonth()];
    const day = date.getUTCDate().toString().padStart(2, '0');

    return (
        <div className="date-image-modal">
            <div className="date-image-month-modal">{month}</div>
            <div className="date-image-day-modal">{day}</div>
        </div>
    );
};

DateImage.propTypes = {
    timestamp: PropTypes.number.isRequired,
};

export default DateImage;
